import { render, staticRenderFns } from "./addProductDialogStep3.vue?vue&type=template&id=4b10aba6&scoped=true&"
import script from "./addProductDialogStep3.vue?vue&type=script&lang=js&"
export * from "./addProductDialogStep3.vue?vue&type=script&lang=js&"
import style0 from "./addProductDialogStep3.vue?vue&type=style&index=0&id=4b10aba6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b10aba6",
  null
  
)

export default component.exports